module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Moviles-5-zoom.35f2991b.png";